// Roles allowed to edit an already-validated requirement IN PLACE (without
// changing its status), from the internal /folders/:id view.
//
// NOTE: this is a UI-only gate. "assistant" is intentionally excluded here,
// but the backend guard (apps/docvault/utils/auth.py STAFF_GROUPS) still treats
// assistant as staff — so this restriction is presentational, not enforced at
// the API.
export const VALID_REQUIREMENT_EDIT_GROUPS = [
  "operations",
  "cja",
  "admin",
] as const;

export type ValidRequirementEditGroup =
  (typeof VALID_REQUIREMENT_EDIT_GROUPS)[number];

/** True when the user may edit a validated requirement in place. */
export const canEditValidRequirement = (
  groups: ReadonlyArray<string | null | undefined> | undefined,
): boolean =>
  Boolean(
    groups?.some(
      (group) =>
        !!group &&
        VALID_REQUIREMENT_EDIT_GROUPS.includes(group as ValidRequirementEditGroup),
    ),
  );
